export const GET_ALL_AGENTS = 'GET_ALL_AGENTS';
export const GET_AGENT_DETAIL = 'GET_AGENT_DETAIL';
export const GET_ALL_AGENTS_LOADING = 'GET_ALL_AGENTS_LOADING';
export const GET_AGENT_TYPES = 'GET_AGENT_TYPES';
export const GET_AGENT_TYPES_LOADING = 'GET_AGENT_TYPES_LOADING';
export const SET_AGENT_COUNT = 'SET_AGENT_COUNT';